<div class="ui segments">
  <div
    class="ui segment"
    style="border-top-left-radius: 8px; border-top-right-radius: 8px"
  >
    <div style="padding: 5px; font-size: 15px" class="segment-header">
      Company Registration and Tax Information
    </div>
  </div>
  <div
    class="ui gray segment"
    [ngClass]="{ loading: pending || loading }"
    style="
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      min-height: 400px;
      width: 100%;
      overflow: auto;
    "
  >
    <div
      class="ui default message"
      [ngClass]="{
        'border-green': rcStatus === 'VERIFIED',
        'border-red': rcStatus !== 'VERIFIED'
      }"
      style="width: 100%"
      *ngIf="ownershipType !== 'foreign_owned'"
    >
      <div class="status">
        {{ rcStatus === "VERIFIED" ? "VERIFIED" : "UNVERIFIED" }}
      </div>
      <div style="position: relative; top: 0.5rem" class="details">
        <h3 style="position: relative; top: 0.6rem" class="mini-card header">
          CAC
        </h3>
        <div
          style="display: flex; justify-content: space-between"
          class="link-flex"
        >
          <h6>
            Registration No:<strong>{{
              organizationDetails?.jpaContractor?.rcNumber ||
                companyDetail?.companyRegNumber ||
                "--"
            }}</strong>
          </h6>
          <a
            style="position: relative; top: 1.4rem"
            routerLink="/contractor/company/profile"
            ><i class="angle right large link icon"></i
          ></a>
        </div>
        <h6>
          Company Type:
          <strong>{{
            organizationDetails?.jpaContractor?.companyType?.optionName ||
              companyDetail?.jpaContractor?.companyType?.optionName ||
              "--"
          }}</strong>
        </h6>
      </div>
    </div>
    <div
      style="height: 90px; width: 100%"
      [ngClass]="{
        'border-green': tinStatus === 'VERIFIED',
        'border-red': tinStatus !== 'VERIFIED'
      }"
      class="ui default message"
      *ngIf="
        ((organizationDetails.jpaContractor.tinNumber && isBusinessName) ||
          !isBusinessName) &&
        ownershipType !== 'foreign_owned'
      "
    >
      <div class="status">
        {{ tinStatus === "VERIFIED" ? "VERIFIED" : "UNVERIFIED" }}
      </div>
      <div style="position: relative; top: 0.1rem" class="details">
        <h3 style="position: relative" class="mini-card header">
          FIRS TAX IDENTIFICATION NUMBER
        </h3>
        <div
          style="
            display: flex;
            justify-content: space-between;
            height: 10px;
            position: relative;
            bottom: 23px;
            margin-top: 15px;
            margin-bottom: 10px;
          "
          class="link-flex"
        >
          <h6>
            <strong>{{
              organizationDetails.jpaContractor.tinNumber || "--"
            }}</strong>
          </h6>
          <a
            style="position: relative; top: 1.4rem"
            routerLink="/contractor/company/profile"
            ><i class="angle right large link icon"></i
          ></a>
        </div>
      </div>
    </div>
    <div
      [ngClass]="{
        'border-green': tccStatus == 'VERIFIED',
        'border-red': tccStatus !== 'VERIFIED'
      }"
      style="width: 100%"
      class="ui default message"
      *ngIf="
        ((record?.firsTccRecord?.tccNumber && isBusinessName) ||
          !isBusinessName) &&
        ownershipType !== 'foreign_owned'
      "
    >
      <!-- <div *ngIf="tccStatus == 'NOT_AVAILABLE'" class="status">
				NOT AVAILABLE
			</div> -->
      <div class="status">
        {{ tccStatus === "VERIFIED" ? "VERIFIED" : "UNVERIFIED" }}
      </div>
      <div style="position: relative" class="details">
        <h3 style="position: relative; top: 0.6rem" class="mini-card header">
          FIRS TAX CLEARANCE
        </h3>
        <div
          style="display: flex; justify-content: space-between"
          class="link-flex"
        >
          <h6>
            TCC No:<strong>{{
              record?.firsTccRecord?.tccNumber || "--"
            }}</strong>
          </h6>
          <a
            style="position: relative; top: 1.4rem"
            routerLink="/contractor/company/record"
            ><i class="angle right large link icon"></i
          ></a>
        </div>
        <h6>
          Expiry Date:
          <strong>{{
            record?.firsTccRecord?.tccExpiryDate
              | date: "d MMM, y h:mm a" || "--"
          }}</strong>
        </h6>
      </div>
    </div>
    <div
      style="height: 90px; width: 100%"
      [ngClass]="{
        'border-green': otherTinStatus === 'VERIFIED',
        'border-red': otherTinStatus !== 'VERIFIED'
      }"
      class="ui default message"
      *ngIf="isBusinessName && ownershipType !== 'foreign_owned'"
    >
      <div class="status">
        {{ otherTinStatus === "VERIFIED" ? "VERIFIED" : "UNVERIFIED" }}
      </div>
      <div style="position: relative; top: 0.1rem" class="details">
        <h3 style="position: relative" class="mini-card header">
          OTHER TAX IDENTIFICATION NUMBER
        </h3>
        <div
          style="
            display: flex;
            justify-content: space-between;
            height: 10px;
            position: relative;
            bottom: 23px;
            margin-top: 15px;
            margin-bottom: 10px;
          "
          class="link-flex"
        >
          <h6>
            <strong>{{
              organizationDetails.jpaContractor.otherTinNumber || "--"
            }}</strong>
          </h6>
          <a
            style="position: relative; top: 1.4rem"
            routerLink="/contractor/company/profile"
            ><i class="angle right large link icon"></i
          ></a>
        </div>
      </div>
    </div>
    <div
      [ngClass]="{
        'border-green': otherTccStatus == 'VERIFIED',
        'border-red': otherTccStatus !== 'VERIFIED'
      }"
      style="width: 100%"
      class="ui default message"
      *ngIf="isBusinessName && ownershipType !== 'foreign_owned'"
    >
      <!-- <div *ngIf="tccStatus == 'NOT_AVAILABLE'" class="status">
				NOT AVAILABLE
			</div> -->
      <div class="status">
        {{ otherTccStatus === "VERIFIED" ? "VERIFIED" : "UNVERIFIED" }}
      </div>
      <div style="position: relative" class="details">
        <h3 style="position: relative; top: 0.6rem" class="mini-card header">
          OTHER TAX CLEARANCE
        </h3>
        <div
          style="display: flex; justify-content: space-between"
          class="link-flex"
        >
          <h6>
            TCC No:<strong>{{
              record?.otherTccRecord?.tccNumber || "--"
            }}</strong>
          </h6>
          <a
            style="position: relative; top: 1.4rem"
            routerLink="/contractor/company/record"
            ><i class="angle right large link icon"></i
          ></a>
        </div>
        <h6>
          Expiry Date:
          <strong>{{
            record?.otherTccRecord?.tccExpiryDate
              | date: "d MMM, y h:mm a" || "--"
          }}</strong>
        </h6>
      </div>
    </div>
    <div
      style="height: 120px; padding-bottom: 16px; width: 100%"
      [ngClass]="{
        'border-green': addressStatus == 'VERIFIED',
        'border-red': addressStatus !== 'VERIFIED'
      }"
      class="ui default message"
    >
      <div class="status">
        {{ addressStatus === "VERIFIED" ? "VERIFIED" : "UNVERIFIED" }}
      </div>
      <div class="details" style="position: relative; bottom: 1.3rem">
        <h3 class="mini-card header" style="position: relative; top: 1.6rem">
          COMPANY ADDRESS
        </h3>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 15px;
            margin-bottom: 10px;
          "
        >
          <h6 style="font-size: 12px; flex-grow: 1; margin-right: 24px">
            <strong
              >{{
                organizationDetails?.jpaContractor?.headOfficeAddressStreet
              }},
              {{ organizationDetails?.jpaContractor?.headOfficeAddressCity }},
              {{
                organizationDetails.jpaContractor.headOfficeAddressState
                  ?.stateName
              }}
            </strong>
          </h6>
          <a
            routerLink="/contractor/company/profile"
            style="position: relative"
          >
            <i
              class="angle right large link icon"
              style="position: absolute; right: 0"
            ></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
